import { render, staticRenderFns } from "./ImportExport.vue?vue&type=template&id=09ff9454&scoped=true&"
import script from "./ImportExport.vue?vue&type=script&lang=js&"
export * from "./ImportExport.vue?vue&type=script&lang=js&"
import style0 from "./ImportExport.vue?vue&type=style&index=0&id=09ff9454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff9454",
  null
  
)

export default component.exports